// Aktivitäten (Agent 5C, Runde 5): Startseite „Art wählen“ (A-01, A-02) und die Listen für Anrufe, E-Mails, SMS, WhatsApp,
// Meetings, Notizen und Custom Activities (A-03 bis A-05, T47). Unterrouten:
//   /aktivitaeten                 Startseite (Arten und Custom-Activity-Typen mit Zahlen)
//   /aktivitaeten/:art            Liste einer Art (anrufe, emails, sms, whatsapp, meetings, notizen)
//   /aktivitaeten/custom/:typId   Liste einer Custom Activity
// Bausteine in `src/aktivitaeten/`, Client `api/aktivitaeten.ts`, Backend `routers/aktivitaeten_liste.py` (API.md 20.4).
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { AktivitaetenListe } from "../aktivitaeten/AktivitaetenListe";
import { AktivitaetenStart } from "../aktivitaeten/AktivitaetenStart";
import { artInfo } from "../aktivitaeten/arten";

function ArtListe() {
  const { art } = useParams();
  const info = artInfo(art);
  // key: beim Wechsel der Art beginnt die Seite mit frischem Zustand (Filter, Spalten, Auswahl)
  return info ? <AktivitaetenListe key={info.art} art={info.art} /> : <Navigate to="/aktivitaeten" replace />;
}

function CustomListe() {
  const { typId } = useParams();
  return typId ? <AktivitaetenListe key={typId} art="custom" typId={typId} /> : <Navigate to="/aktivitaeten" replace />;
}

export default function Aktivitaeten() {
  return (
    <Routes>
      <Route index element={<AktivitaetenStart />} />
      <Route path="custom/:typId" element={<CustomListe />} />
      <Route path=":art" element={<ArtListe />} />
      <Route path="*" element={<Navigate to="/aktivitaeten" replace />} />
    </Routes>
  );
}
